import { apiGetTwitterHype } from "@shared/api/twitter_hype/getTwitterHypeData";
import { testData } from "./testData/testData";

const TwitterHype = {
  namespaced: true,

  state: { 
    //Словарь сигналов
    data: {},
    //Карта отрисовки
    map: [],
    //Ссылка на следующие страницу пагинации
    nextPageLink: null,
    //Готовы ли данные для выдачи
    isReady: false,
    //Запущен ли процесс загрузки данных с сервера
    isLoading: false,
  },

  actions:{
    //Метод инициализации сигналов
    async init({ state, commit, dispatch }){
      await dispatch('getData');
      if (Object.keys(state.data).length === 0) return;
      commit('SET_READY_FLAG');
    },

    async getData({ commit }){
      commit('TOGGLE_LOADING_FLAG', true);
      try{
        const data = await apiGetTwitterHype();
        commit('SET_DATA', data.results);
      } catch (error) {
        console.error('Ошибка при загрузке Twitter Hype данных, используем тестовые данные:', error);
        // Используем тестовые данные если API недоступно
        const testDataResult = testData();
        commit('SET_DATA', testDataResult.results);
      } finally{
        commit('TOGGLE_LOADING_FLAG', false);
      }
    }
  },

  mutations: {
    //Добавлям данные в хранилище
    SET_DATA(state, data){
      data.forEach(item => {
        if(!state.map.includes(item.id)){
          state.data[item.id] = item;
          state.map.push(item.id);
        }
      });
    },

    //Очистить данные
    CLEAR_DATA(state){
      state.data = {};
      state.map = [];
      state.nextPageLink = null;
    },

    //Отмечаем, что начался/закончился процесс получения данных с сервера
    TOGGLE_LOADING_FLAG(state, status){ state.isLoading = status; },

    //Отмечаем, что данные сигналов готовы к использованию
    SET_READY_FLAG(state){ state.isReady = true; },
  },
}

export default TwitterHype;